import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ITags } from "../../../model";

export const TagsSelect = Select.ofType<ITags>();

export const filterTags: ItemPredicate<ITags> = (query, tag) => {
  return tag.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderTags: ItemRenderer<ITags> = (
  tag,
  { handleClick, modifiers },
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={tag.id}
      text={tag.name}
      onClick={handleClick}
      label={(tag.tag)}
    />
  );
};
